import React, { useEffect, useRef, useState } from 'react';
import {
  FaHome,
  FaInfoCircle,
  FaEnvelope,
  FaInstagram,
  FaWhatsapp
} from 'react-icons/fa';
import '../styles/header.css';
import config from '../config';

export default function Header({ onContactClick, onHomeClick, onAboutClick }) {
  const [activeSection, setActiveSection] = useState('home');
  const observerRef = useRef(null);

  useEffect(() => {
    const aboutEl = document.getElementById('about');

    if (!aboutEl) {
      console.warn('About section not found');
      return;
    }

    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setActiveSection('about');
        } else {
          setActiveSection('home');
        }
      },
      {
        root: null,
        threshold: 0.4 // 40% visible = active
      }
    );

    observerRef.current.observe(aboutEl);

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const scrollToAbout = () => {
    const aboutEl = document.getElementById('about');
    if (!aboutEl) return;

    aboutEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    if (onHomeClick) {
      onHomeClick();
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleAboutClick = (e) => {
    e.preventDefault();
    if (onAboutClick) {
      onAboutClick();
    } else {
      scrollToAbout();
    }
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    if (onContactClick) {
      onContactClick();
    }
  };

  return (
    <header className="header">
      <nav>
        <a
          href="#home"
          className={activeSection === 'home' ? 'active' : ''}
          onClick={handleHomeClick}
        >
          <FaHome className="nav-icon" />
          <span className="nav-text">Home</span>
        </a>

        <a
          href="#about"
          className={activeSection === 'about' ? 'active' : ''}
          onClick={handleAboutClick}
        >
          <FaInfoCircle className="nav-icon" />
          <span className="nav-text">About</span>
        </a>

        <a
          href="#contact"
          onClick={handleContactClick}
        >
          <FaEnvelope className="nav-icon" />
          <span className="nav-text">Contact</span>
        </a>
      </nav>

      <div className="header-icons" style={{ display: 'none' }}>
        <a
          href={`https://wa.me/${config.whatsapp.phoneNumber}?text=${encodeURIComponent(
            config.whatsapp.defaultMessage
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="icon" />
        </a>

        <a
          href={config.social.instagram}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className="icon" />
        </a>
      </div>
    </header>
  );
}
